// extracted by mini-css-extract-plugin
module.exports = {"orderedList":"ordered_list_orderedList__1pabq"};